<template>  

  <VUEModal :Titolo="Titolo" 
            :Programma="''" 
            :Altezza="AltezzaPopup" 
            :Larghezza="'900px'" 
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            @onClickChiudiModal="OnClickChiudiModal">

    <template v-slot:Body>

      <div style="display:flex; margin-bottom: 2%; justify-content: flex-end; align-items: center; line-height: 1.2;">
        <img @click="OnClickImpostazioniBande()" src="../../../src/assets/images/Impostazioni.png" :title="this.GetTraduzioneLabel('VUEPopupModulazioneGrafici','TKN_IMP_BANDA',this.LinguaUtente)" style="height:25px; width:auto;cursor: pointer;">
        
        <button @click="OnClickImpostazioniBande" type="button" class="btn btn-info" style="width:10%; background: white; border: none; color: black !important; font-size: 16px;">
          {{ this.GetTraduzioneLabel('VUEPopupModulazioneGrafici','TKN_IMP_BANDA',this.LinguaUtente) }}
        </button>

        <img @click="OnClickEliminaBande()" src="../../../src/assets/images/Cestino.png" :title="this.GetTraduzioneLabel('VUEPopupModulazioneGrafici','TKN_ELIMINA_BANDE',this.LinguaUtente)" style="height:25px;width:auto;margin-left: 6%;cursor: pointer;">
        
        <button @click="OnClickEliminaBande" type="button" class="btn btn-danger" style="width:10%; background: white; border: none; color: black !important; font-size: 16px;margin-left: -0.5%">
          {{ this.GetTraduzioneLabel('VUEPopupModulazioneGrafici','TKN_ELIMINA_BANDE',this.LinguaUtente) }}
        </button>

        <button @click="OnClickModificaRiepilogoPDF" type="button" class="btn btn-info" style="font-weight:bold;width:20%; margin-left: 20%;">
          {{ this.GetTraduzioneLabel('VUEPopupModulazioneGrafici','TKN_RIEPILOGO_PDF',this.LinguaUtente) }}
        </button>

        <button @click="OnClickAggiungiBanda" type="button" class="btn btn-success" style="font-weight:bold;width:20%; margin-left: 5%;">
          {{ this.GetTraduzioneLabel('Generic','TKN_AGGIUNGI',this.LinguaUtente) }}
        </button>
      </div>

      <table cellpadding="0" cellspacing="0" width="100%" class="table table-bordered table-striped sortable">
        <thead style="background-color:#60604d;color:white">
          <tr>
            <th width="20%">{{ this.GetTraduzioneLabel('Generic','TKN_NOME',this.LinguaUtente) }}</th>
            <th width="18%">{{ this.GetTraduzioneLabel('Generic','TKN_ALTEZZA',this.LinguaUtente) }}</th>
            <th width="27%">{{ this.GetTraduzioneLabel('Generic','TKN_COLORE',this.LinguaUtente) }}</th>                                   
            <th width="10%">{{ this.GetTraduzioneLabel('VUEAppContentGestioneUtenti','TKN_APP_CON_GEST_UTENTE_AZIONI',this.LinguaUtente) }}</th>
          </tr>
        </thead>
        <tbody :style="{'background-color' : Arancione}">
          <tr v-for="(Banda, chiave) in ConfigurazioneJSON.BANDE" :key="chiave">
            <td style="vertical-align:middle">{{ Banda.NOME_BANDA }}</td>
            <td style="vertical-align:middle">{{ Banda.ALTEZZA_BANDA }}</td>
            <td style="vertical-align:middle">{{ Banda.COLORE_BANDA }}</td>                                   
            <td style="vertical-align:middle;text-align:center;">
              <i class="fa fa-pencil text-warning ZMIconButton" @click="OnClickApriBanda(Banda, chiave)" style="margin-right:10px"></i>
              <i class="fa fa-trash-o text-danger ZMIconButton" @click="OnClickEliminaCurrentBanda(chiave)" style="margin-right:10px"></i>
              <i v-if="chiave !== 0" class="fa fa-arrow-up ZMIconButton" @click="OnClickSpostaInAlto(chiave)" style="margin-right:4px"></i>
              <i v-if="chiave === 0" class="fa fa-trash-o" style="margin-right:4px; opacity: 0;"></i>
              <i v-if="chiave !== ConfigurazioneJSON.BANDE.length - 1" class="fa fa-arrow-down ZMIconButton" @click="OnClickSpostaInBasso(chiave)"></i>
              <i v-if="chiave === ConfigurazioneJSON.BANDE.length - 1" class="fa fa-trash-o" style="opacity: 0;"></i>
            </td>
          </tr>
        </tbody>
      </table>

    </template>
   
    <template  v-slot:Footer>
      <button v-if="CanRecord()" type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:20%" @click="OnClickChiudiModal" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="CanRecord()" type="button" class="btn btn-success" style="float:right;margin-left:10px;font-weight:bold;width:20%" @click="OnClickConfermaModal"  data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
      <button v-if="CanRecord()" type="button" class="btn btn-twitter" style="float:right;font-weight:bold;font-size:1em;padding:0px 10px 0px 10px;width:20%" @click="OnClickConfermaModal(false)"  data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_APPLICA',this.LinguaUtente) }}</button>
    </template>
 
  </VUEModal>

  <VUEPopupModificaBanda v-if="PopupModificaBanda" 
                                :Titolo="this.GetTraduzioneLabel('Generic','TKN_DMS_EW',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('VUEPopupModulazioneGrafici','TKN_MOD_BANDA',this.LinguaUtente) + ']'" 
                                :AltezzaPopup="AltezzaPopup" 
                                :ObjBanda="BandaSelezionata"
                                :VettoreModuli="VettoreModuli"
                                :IsEstensimetroPresente="IsEstensimetroPresente"
                                @OnClickConfermaPopup="OnClickConfermaPopupModificaBanda"
                                @OnClickChiudiPopup="OnClickChiudiPopupModificaBanda"/>

  <VUEModal v-if="PopupConfigRiepilogo"
            :Titolo="this.GetTraduzioneLabel('Generic','TKN_DMS_EW',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('VUEPopupModulazioneGrafici', 'TKN_CONFIG_RIEPILOGO', this.LinguaUtente) + ']'" 
            :Programma="''" 
            :Altezza="AltezzaPopup" 
            :Larghezza="'900px'" 
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            @onClickChiudiModal="OnClickAnnullaConfigRiepilogo">

    
    <template v-slot:Body>    
      <div style="display: flex; justify-content: flex-start; align-items: flex-start; height: 50px">
        <text style="width:200px;margin-top:2px;font-size:16px; margin-left: 30px;"> {{this.GetTraduzioneLabel('VUEPopupModulazioneGrafici','TKN_ABILITA_RIEPILOGO',this.LinguaUtente)}}</text>
        <input class="form-control" style="width:30px;margin-top:4px;padding: 0px;height: 20px; margin-left: 20px;" type="checkbox" v-model="ConfigurazioneJSON.SOMMARIO.Visibile"/>
      </div>  

      <div style="display: flex; justify-content: space-evenly">        
        <div style="width: 250px; height: 300px; border: 1.5px solid #ccc; border-radius: 12px; overflow-y: auto;">
          <div style="display: flex; flex-direction: column;">
            <div v-for="Campo in ConfigurazioneJSON.SOMMARIO.DatiMostrati" :key="Campo" style="display: flex; align-items: center; justify-content: space-between; height: 30px; padding: 0 12px; border-bottom: 1px solid #eee;">              
              <span style="font-size: 13px; color: #222;">{{ Campo.Name }}</span>
              <i class="fa fa-minus" style="color: red;" @click="RimuoviCampo(Campo.Id)"></i>
            </div>
          </div>
        </div>

        <div style="width: 250px; height: 300px; border: 1.5px solid #ccc; border-radius: 12px; overflow-y: auto;">
          <div style="display: flex; flex-direction: column;">
            <div v-for="Campo in CampiSommarioMostrati" :key="Campo" style="display: flex; align-items: center; justify-content: space-between; height: 30px; padding: 0 12px; border-bottom: 1px solid #eee;">              
              <span style="font-size: 13px; color: #222;">{{ Campo.Name }}</span>
              <i class="fa fa-plus" style="color: green;" @click="AggiungiCampo(Campo.Id)"></i>
            </div>
          </div>
        </div>
      </div>

    </template>        
            
    <template  v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:20%" @click="OnClickAnnullaConfigRiepilogo" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" class="btn btn-success" style="float:right;margin-left:10px;font-weight:bold;width:20%" @click="OnClickConfermaConfigRiepilogo"  data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEPopupImpostazioniModulo v-if="PopupImpostazioniModulo" 
                                :Titolo="this.GetTraduzioneLabel('Generic','TKN_DMS_EW',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('VUEPopupModulazioneGrafici','TKN_IMP_BANDA',this.LinguaUtente) + ']'" 
                                :AltezzaPopup="AltezzaPopup" 
                                :ObjListaModelli="ObjListaModelli"
                                :ObjModulo="this.ConfigurazioneJSON"
                                @OnClickConfermaPopup="OnClickConfermaPopupImpostazioniModulo"
                                @OnClickChiudiPopup="OnClickChiudiPopupImpostazioniModulo"/>

</template>

<script>

import VUEModal from '@/utils/VUEModal.vue';            
import { SystemInformation, COLORI_PANTONE } from '@/SystemInformation'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import VUEPopupModificaBanda from '../../components/Popups/VUEPopupModificaBanda.vue';
import VUEPopupImpostazioniModulo from '../../components/Popups/VUEPopupImpostazioniModulo.vue';

export default 
{
  data()
  {
   return {
            LinguaUtente            : SystemInformation.UserInformation.Lingua,
            ConfigurazioneJSON      : [],
            NomeConfigurazione      : '',
            ImpostazioneDefault     : {},
            BandaSelezionata        : '',
            PopupModificaBanda      : false,
            PopupImpostazioniModulo : false,
            PopupConfigRiepilogo    : false,
            Marrone                 : COLORI_PANTONE.Marrone,
            Arancione               : COLORI_PANTONE.Arancione,
            IndexBandaAperta        : -1,
            IsNuovaBanda            : false,
            CampiSommario           : [],
            TmpConfigSommarioPDF    : null
          }
  },

  props : ['AltezzaPopup', 'Titolo', 'ObjCatena', 'AltezzaPagina', 'JSONGraficiModulari', 'VettoreModuli', 'IsEstensimetroPresente', 'ObjListaModelli'],
  emits : ['OnClickChiudiPopup'],
  mixins: [MixInsGestioneTraduzioni],
  components: { 
                VUEModal,
                VUEPopupModificaBanda,
                VUEPopupImpostazioniModulo,
              },

  methods :
  {
    AggiungiCampo(Id)
    {
      let index = this.CampiSommario.findIndex((element) => {return element.Id == Id})
      if (index != -1)
      {
        this.ConfigurazioneJSON.SOMMARIO.DatiMostrati.push(this.CampiSommario[index])
        this.CampiSommario[index].Mostra = false
      }
    },

    RimuoviCampo(Id)
    {
      let index = this.CampiSommario.findIndex((element) => {return element.Id == Id})
      if (index != -1)
      {        
        this.CampiSommario[index].Mostra = true
        let IndexToRemove = this.ConfigurazioneJSON.SOMMARIO.DatiMostrati.findIndex((element) => {return element.Id == Id})
        if (IndexToRemove != -1)
          this.ConfigurazioneJSON.SOMMARIO.DatiMostrati.splice(IndexToRemove, 1) 
      }
    },

    OnClickChiudiModal()
    {
      this.$emit('OnClickChiudiPopup', true, false)
    },

    OnClickModificaRiepilogoPDF()
    {
      if (this.ConfigurazioneJSON.SOMMARIO == null)
      {
        this.ConfigurazioneJSON.SOMMARIO  = {
                                              Visibile : false,
                                              DatiMostrati : []
                                            }
      }
      this.TmpConfigSommarioPDF = JSON.parse(JSON.stringify(this.ConfigurazioneJSON.SOMMARIO))
      this.PopupConfigRiepilogo = true
    },

    OnClickConfermaConfigRiepilogo()
    {
      this.PopupConfigRiepilogo = false
      this.TmpConfigSommarioPDF = null
    },

    OnClickAnnullaConfigRiepilogo()
    {
      this.PopupConfigRiepilogo = false
      this.ConfigurazioneJSON.SOMMARIO = JSON.parse(JSON.stringify(this.TmpConfigSommarioPDF))
      this.TmpConfigSommarioPDF = null
    },

    OnClickAggiungiBanda()
    {
      this.ConfigurazioneJSON.BANDE.push({
                                            NOME_BANDA     : '',
                                            ALTEZZA_BANDA  : '',
                                            COLORE_BANDA   : this.Marrone,
                                            NASCOSTO       : false,
                                            MODULO_GRAFICO : []
                                          })
      this.BandaSelezionata   = this.ConfigurazioneJSON.BANDE[(this.ConfigurazioneJSON.BANDE.length -1)]
      this.IndexBandaAperta   = this.ConfigurazioneJSON.BANDE.length -1
      this.IsNuovaBanda       = true
      this.PopupModificaBanda = true 
    },

    OnClickApriBanda(Banda, Indice)
    {
      this.BandaSelezionata   = Banda
      this.IndexBandaAperta   = Indice
      this.PopupModificaBanda = true
    },

    OnClickEliminaBande()
    {
      this.ConfigurazioneJSON.BANDE = []
    },

    OnClickImpostazioniBande()
    {
      this.PopupImpostazioniModulo = true
    },

    OnClickEliminaCurrentBanda(Indice)
    {
      this.ConfigurazioneJSON.BANDE.splice(Indice, 1)
    },

    OnClickSpostaInAlto(Indice)
    {
      let BandaTmp = this.ConfigurazioneJSON.BANDE[Indice]
      this.ConfigurazioneJSON.BANDE.splice(Indice, 1)
      this.ConfigurazioneJSON.BANDE.splice(Indice - 1, 0, BandaTmp)
    },

    OnClickSpostaInBasso(Indice)
    {
      let BandaTmp = this.ConfigurazioneJSON.BANDE[Indice]
      this.ConfigurazioneJSON.BANDE.splice(Indice, 1)
      this.ConfigurazioneJSON.BANDE.splice(Indice + 1, 0, BandaTmp)
    },

    OnClickChiudiPopupModificaBanda()
    {
      if(this.IsNuovaBanda)
      {
        this.ConfigurazioneJSON.BANDE.splice(this.IndexBandaAperta, 1)
        this.IsNuovaBanda       = false
      }
      this.PopupModificaBanda = false
    },

    OnClickConfermaPopupModificaBanda(JSONBanda)
    {
      this.ConfigurazioneJSON.BANDE[this.IndexBandaAperta] = JSONBanda
      this.PopupModificaBanda = false
      this.IsNuovaBanda       = false
    },

    OnClickConfermaPopupImpostazioniModulo(Modelli, LsChiaviDaEliminare, ChiaveDefault, ObjModDaCaricare, NomeModDaCaricare)
    {
      let NuoviModelli = Modelli.filter(Modello => Modello.ChiaveModello == -1)

      if(LsChiaviDaEliminare.length != 0 || NuoviModelli.length != 0 || ChiaveDefault != -1)
      {
        let Self                           = this
        let ParametriQuery                 = {}
        ParametriQuery.IdSito              = this.ObjCatena.DatiCatena.CHIAVE_SITO
        ParametriQuery.IdCatena            = this.ObjCatena.DatiCatena.CHIAVE
        ParametriQuery.NomeConf            = this.NomeConfigurazione ? this.NomeConfigurazione : ''
        ParametriQuery.JSONConf            = JSON.stringify(this.ConfigurazioneJSON)
        ParametriQuery.Modifica            = true
        ParametriQuery.CambiaModelli       = true
        ParametriQuery.LsChiaviDaEliminare = LsChiaviDaEliminare.length != 0 ? LsChiaviDaEliminare : null
        ParametriQuery.NuoviModelli        = NuoviModelli.length != 0 ? NuoviModelli : null
        ParametriQuery.ChiaveDefault       = ChiaveDefault != 0 ? ChiaveDefault : null
  
        SystemInformation.AdvQuery.ExecuteExternalScript('ExtraHandleConfigurazioneGrafici', ParametriQuery, function() 
        {
          if(ObjModDaCaricare == null)
          {
            Self.$emit('OnClickChiudiPopup', false)
          }
        },
        function(ErrorMessage,DescrErrore)
        {
          alert(ErrorMessage + '[' + DescrErrore + ']')
        }) 
      }

      if(ObjModDaCaricare != null)
      {
        this.NomeConfigurazione = NomeModDaCaricare
        this.ConfigurazioneJSON = JSON.parse(ObjModDaCaricare)
        this.OnClickConfermaModal(false)
      }

      this.PopupImpostazioniModulo = false
    },

    OnClickChiudiPopupImpostazioniModulo()
    {
      this.PopupImpostazioniModulo = false
    },

    OnClickConfermaModal(ChiudiPopup = true)
    {
      let Self                     = this
      let ParametriQuery           = {}
      ParametriQuery.IdSito        = this.ObjCatena.DatiCatena.CHIAVE_SITO,
      ParametriQuery.IdCatena      = this.ObjCatena.DatiCatena.CHIAVE,
      ParametriQuery.NomeConf      = this.NomeConfigurazione ? this.NomeConfigurazione : '',
      ParametriQuery.JSONConf      = JSON.stringify(this.ConfigurazioneJSON),
      ParametriQuery.Modifica      = true,
      ParametriQuery.CambiaModelli = false,

      SystemInformation.AdvQuery.ExecuteExternalScript('ExtraHandleConfigurazioneGrafici', ParametriQuery, function() 
      {
        Self.$emit('OnClickChiudiPopup', ChiudiPopup)
      },
      function(ErrorMessage,DescrErrore)
      {
        alert(ErrorMessage + '[' + DescrErrore + ']')
      }) 
    },

    CanRecord()
    {
      return true
    },
  },

  computed :
  {
    CampiSommarioMostrati:
    {
      get()
      {
        return this.CampiSommario.filter((element) => {return element.Mostra})
      }
    }
  },

  beforeMount()
  {
    this.CampiSommario = [
                           {Id: 'PROFONDITA', Name: this.GetTraduzioneLabel('SommarioPDF','TKN_PROFONDITA',this.LinguaUtente), Mostra : true},
                           {Id: 'MODULO', Name: this.GetTraduzioneLabel('SommarioPDF','TKN_MODULO',this.LinguaUtente), Mostra : true},
                           {Id: 'PITCH', Name: this.GetTraduzioneLabel('SommarioPDF','TKN_PITCH',this.LinguaUtente), Mostra : true},
                           {Id: 'ROLL', Name: this.GetTraduzioneLabel('SommarioPDF','TKN_ROLL',this.LinguaUtente), Mostra : true},
                           {Id: 'SPOST_NORD', Name: this.GetTraduzioneLabel('SommarioPDF','TKN_SPOST_NORD',this.LinguaUtente), Mostra : true},
                           {Id: 'SPOST_EST', Name: this.GetTraduzioneLabel('SommarioPDF','TKN_SPOST_EST',this.LinguaUtente), Mostra : true},
                           {Id: 'SPOST_TOT', Name: this.GetTraduzioneLabel('SommarioPDF','TKN_SPOST_TOT',this.LinguaUtente), Mostra : true},
                           {Id: 'AZIMUT', Name: this.GetTraduzioneLabel('SommarioPDF','TKN_AZIMUT',this.LinguaUtente), Mostra : true},
                           {Id: 'TEMPERATURA', Name: this.GetTraduzioneLabel('SommarioPDF','TKN_TEMPERATURA',this.LinguaUtente), Mostra : true},
                         ]
    this.NomeConfigurazione = this.JSONGraficiModulari.NomeConfig
    
    if(this.JSONGraficiModulari != '' && this.JSONGraficiModulari.JSONConfig != '')
    {
      this.ConfigurazioneJSON = JSON.parse(this.JSONGraficiModulari.JSONConfig)
      if (this.ConfigurazioneJSON.SOMMARIO != null)
      {
        this.ConfigurazioneJSON.SOMMARIO.DatiMostrati.forEach((element) =>
        {
          let index = this.CampiSommario.findIndex((Campo) => {return Campo.Id == element.Id})
          if (index != -1)
            this.CampiSommario[index].Mostra = false
        }) 
      }
    }
    else
    {
      this.ConfigurazioneJSON       = {}
      this.ConfigurazioneJSON.BANDE = []
    }
  }
  
}
</script>